import { BUSINESS_AUDIENCE_FILTER, isAudienceSeparationEnabled } from '@pkg/config/sanity/audience';
import { DOCUMENT } from '@pkg/config/sanity/schemas';
import { buildPageBySlugQuery, type PageBySlugPath } from '@pkg/sanity-utils/queries/pageBySlug';
import { slugWithParents } from '@pkg/sanity-utils/slugWithParents';
import { businessPageFields, businessTranslationFields } from './pageById';

/**
 * Business audience page-by-slug — same nesting rules as www, shared via
 * {@link buildPageBySlugQuery}.
 *
 * With `SANITY_STUDIO_BUSINESS_WORKSPACE_ENABLED` on, untagged B2B acquisition pages are
 * legacy business content: they have no audience tag, but they still render here (and
 * apps/web stops serving them). With the flag off, www keeps serving them and this query
 * applies the business audience filter alone.
 */
export const businessPageAudienceFilter = isAudienceSeparationEnabled()
  ? `(
  ${BUSINESS_AUDIENCE_FILTER}
  || (!defined(audience._ref) && _type in ["${DOCUMENT.ACQUISITION_B2B_PAGES}", "${DOCUMENT.INITIATIVE_B2B_PAGES}"])
)`
  : BUSINESS_AUDIENCE_FILTER;

export const businessPageBySlug = (path?: PageBySlugPath) => buildPageBySlugQuery(path, {
  audienceFilter: businessPageAudienceFilter,
  pageFields: `${businessPageFields},
  ${businessTranslationFields}`,
});

/** Slug-only lookup for the language picker: the same page in another locale. */
export const businessPageSlugBySlug = (path?: PageBySlugPath) => buildPageBySlugQuery(path, {
  audienceFilter: businessPageAudienceFilter,
  pageFields: slugWithParents,
});
